/* eslint-disable no-undef */
import { lazy } from "react";

import ROUTE_CONSTANT from "./routeconstants.js";

const LoginPageComponent = lazy(() => import("../pages/login/LoginView")),
  landingPage = lazy(() => import("../pages/landingPage/Landing.jsx")),
  LoginPage = lazy(() => import("../pages/landingPage/Login.jsx")),
  Contact = lazy(() => import("../pages/landingPage/ContactUs.jsx")),
  Demo = lazy(() => import("../pages/home/homeComponent/BookDemo")),
  DashBoardView = lazy(() => import("../pages/Dashboard/Dashboard")),
  Notifications = lazy(() => import("../pages/Notification/Notifications")),
  CreateNotifications = lazy(() =>
    import("../pages/Notification/CreateNotification")
  ),
  OnboardOrganization = lazy(() =>
    import("../pages/organization/OnboardOrganization")
  ),
  ViewUser = lazy(() => import("../pages/organization/user/ViewUser")),
  OrganizationSpecificDetails = lazy(() =>
    import("../pages/organization/organizationSpecificDetails")
  ),
  ThankYou = lazy(() =>
    import("../pages/organization/thankYouScreen/ThankYouScreen")
  ),
  EditUser = lazy(() => import("../pages/organization/user/editUser")),
  HomeAdmin = lazy(() => import("../pages/organization/homeAdmin/HomeAdmin")),
  ViewOrganization = lazy(() =>
    import("../pages/organization/ViewOrganization")
  ),
  OrganizationChart = lazy(() =>
    import("../pages/home/TeamStructure/OrganizationChart")
  ),
  Logs = lazy(() => import("../pages/organization/orgLogs/Logs.jsx")),
  // Portal role Routes
  PortalRole = lazy(() =>
    import("../pages/organization/portalRole/PortalRole")
  ),
  ViewPortalRole = lazy(() =>
    import("../pages/organization/portalRole/ViewPortalRole")
  ),
  PortalRoleTab = lazy(() =>
    import("../pages/organization/portalRole/PortalRoleTab")
  ),
  Tasktype = lazy(() => import("../pages/workflow/taskType/tasktypeTabs")),
  DepartmentAndRoles = lazy(() =>
    import("../pages/workflow/departmentAndRoles/DeparmentAndRoles")
  ),
  EditDepartmentAndRoles = lazy(() =>
    import("../pages/workflow/departmentAndRoles/EditDepartmentAndRoles")
  ),
  TypeOfEmployment = lazy(() =>
    import("../pages/workflow/typeOfEmployment/TypeOfEmployment")
  ),
  EditTypeOfEmployment = lazy(() =>
    import("../pages/workflow/typeOfEmployment/EditTypeOfEmployment")
  ),
  ApprovalHierachy = lazy(() =>
    import("../pages/workflow/approvalHierarchy/approvalHierarchyTabs")
  ),
  ViewApprovalHierarchy = lazy(() =>
    import("../pages/workflow/approvalHierarchy/viewApprovalHierarchy")
  ),
  ApprovalHierarchySpecificDetails = lazy(() =>
    import(
      "../pages/workflow/approvalHierarchy/approvalHierarchyspecificDetails"
    )
  ),
  ScreenConfiguration = lazy(() =>
    import("../pages/workflow/screenConfig/ScreenConfig")
  ),
  ViewTaskType = lazy(() => import("../pages/workflow/taskType/viewTasktype")),
  UpdateTaskTypeAssign = lazy(() =>
    import("../pages/workflow/taskType/updateTasktype")
  ),
  Email = lazy(() => import("../pages/organization/email/Email")),
  EmailConfig = lazy(() => import("../pages/EmailConfig/EmailConfig.jsx")),
  EditEmailConfig = lazy(() =>
    import("../pages/EmailConfig/EditEmailConfig.jsx")
  ),
  Screens = lazy(() => import("../pages/organization/screenConfig/Screens")),
  ResetPassword = lazy(() => import("../pages/passWord/ResetPassword")),
  PasswordQuestions = lazy(() =>
    import("../pages/passWord/passWordQuestionsComponent")
  ),
  ViewErrors = lazy(() =>
    import("../../src/pages/organization/Errors/ViewErrors")
  ),
  ViewEmails = lazy(() =>
    import("../../src/pages/organization/email/ViewEmails.jsx")
  ),
  NotificationTab = lazy(() => import("../pages/Notification/NotificationTab")),
  CreateUser = lazy(() => import("../pages/organization/user/CreateUser")),
  ViewBookDemo = lazy(() => import("../pages/landingPage/BookDemo.jsx")),
  CreateTempleMaster = lazy(() => import("../pages/templeAndSevaMaster/CreateTempleMaster.jsx")),
  ViewTempleMasters = lazy(() => import("../pages/templeAndSevaMaster/viewTempleMasters.jsx")),
  CreateSevaType = lazy(() => import("../pages/templeAndSevaMaster/CreateSevaType.jsx")),
  ViewSevaTypes = lazy(() => import("../pages/templeAndSevaMaster/viewSevaTypes.jsx")),
  CreateDonationType = lazy(() => import("../pages/templeAndSevaMaster/DonationType.jsx")),
  ViewDonationTypes = lazy(() => import("../pages/templeAndSevaMaster/viewDonationTypes.jsx")),
  ScheduleSeva = lazy(() => import("../pages/templeAndSevaMaster/SevaSchedule.jsx")),
  ViewSevaSchedules = lazy(() => import("../pages/templeAndSevaMaster/viewSevaSchedules.jsx")),
  CreateDevotee = lazy(() => import("../pages/Devotee/CreateDevotee.jsx")),
  DevoteeOccasion = lazy(() => import("../pages/Devotee/DevoteeOccasion.jsx")),
  ViewDevotees = lazy(() => import("../pages/Devotee/ViewDevotees.jsx")),
  CreateDonations = lazy(() => import("../pages/Donations/CreateDonations.jsx")),
  CreateDonationItems = lazy(() => import("../pages/Donations/CreateDonationItems.jsx")),
  CreatePoojaBooking = lazy(() => import("../pages/PoojaReceipt/CreatePoojaBooking.jsx")),
  CreateReceiptAttachment = lazy(() => import("../pages/PoojaReceipt/CreateReceiptAttachment.jsx")),
  ViewDevoteeOccasions = lazy(() => import("../pages/Devotee/ViewDevoteeOccasions.jsx")),
  createVoucher = lazy(() => import("../pages/Vouchers/CreateVoucher.jsx")),
  EditTempleMasters = lazy(() => import("../pages/templeAndSevaMaster/CreateTempleMaster.jsx")),
  CreatePoojaReciept = lazy(() => import("../pages/PoojaReceipt/CreatePoojaReceipt.jsx")),
  ViewPoojaReceipts = lazy(() => import("../pages/PoojaReceipt/ViewPoojaReceipts.jsx")),
  viewReceiptAttachment = lazy(() => import("../pages/PoojaReceipt/ViewReceiptAttachements.jsx")),
  MyProfile = lazy(() => import("../pages/myProfile/myProfile")),
  EditSeva = lazy(() => import("../pages/templeAndSevaMaster/CreateSevaType.jsx")),
  EditDonationType = lazy(() => import("../pages/templeAndSevaMaster/DonationType.jsx")),
  EditScheduleSeva = lazy(() => import("../pages/templeAndSevaMaster/SevaSchedule.jsx")),
  EditDevotees = lazy(() => import("../pages/Devotee/CreateDevotee.jsx")),
  EditDevoteeOccasions = lazy(() => import("../pages/Devotee/DevoteeOccasion.jsx")),
  ViewPoojaBooking = lazy(() => import("../pages/PoojaReceipt/viewPoojaBooking.jsx")),
  EditPoojaBooking = lazy(() => import("../pages/PoojaReceipt/CreatePoojaBooking.jsx")),
  editReceiptAttachment = lazy(() => import("../pages/PoojaReceipt/CreateReceiptAttachment.jsx")),
  ViewVouchers = lazy(() => import("../pages/Vouchers/viewVochers.jsx")),
  ViewDonations = lazy(() => import("../pages/Donations/viewDonations.jsx")),
  EditDonations = lazy(() => import("../pages/Donations/CreateDonations.jsx")),
  ViewDonationItems = lazy(() => import("../pages/Donations/viewDonationItem.jsx")),
  EditDonationItems = lazy(() => import("../pages/Donations/CreateDonationItems.jsx")),
  DailyReceipt = lazy(() => import("../pages/TempleReports/dailyReports.jsx")),
  SaswataAnnaPrsadaExcel = lazy(() => import("../pages/TempleReports/saswataAnnaprasadExcel.jsx")),
  DonorReport = lazy(() => import("../pages/TempleReports/donorReports.jsx")),
  BalanceSheetReports = lazy(() => import("../pages/TempleReports/balanceSheet.jsx")),
  DevoteeBySevaTypes = lazy(() => import("../pages/TempleReports/devoteesBySevaTypeReport.jsx")),
  Approvals = lazy(() => import("../pages/employee/approvals/approvalTabs.jsx"))

const routes = [

  {
    path: ROUTE_CONSTANT.LOGIN,
    exact: true,
    component: LoginPage,
    isPublic: true,
  },
  {
    path: ROUTE_CONSTANT.LANDING,
    exact: true,
    component: DashBoardView,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.HOME,
    exact: true,
    component: DashBoardView,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.NOTIFICATION,
    exact: true,
    component: Notifications,
    depts: ["*"],
    roles: ["*"],
  },

  {
    path: ROUTE_CONSTANT.CREATE_NOTIFICATION,
    exact: true,
    component: CreateNotifications,
    depts: ["*"],
    roles: ["*"],
  },

  {
    path: ROUTE_CONSTANT.CONTACT,
    exact: true,
    component: Contact,
    isPublic: true,
  },
  {
    path: ROUTE_CONSTANT.DEMO,
    exact: true,
    component: Demo,
    isPublic: true,
  },
  {
    path: ROUTE_CONSTANT.ONBOARD_ORGANIZATION,
    exact: true,
    component: OnboardOrganization,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.VIEW_EMAILS,
    exact: true,
    component: ViewEmails,
    depts: ["*"],
    roles: ["*"],
  },

  {
    path: ROUTE_CONSTANT.CREATE_USER,
    exact: true,
    component: CreateUser,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.THANK_YOU,
    exact: true,
    component: ThankYou,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.VIEW_USER,
    exact: true,
    component: ViewUser,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.EDIT_USER,
    exact: true,
    component: EditUser,
    depts: ["*"],
    roles: ["*"],
  },

  {
    path: ROUTE_CONSTANT.VIEW_ORGANIZATION,
    exact: true,
    component: ViewOrganization,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.ORGANIZATION_VIEW_SPECIFIC,
    exact: true,
    component: OrganizationSpecificDetails,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.HOME_ADMIN,
    exact: true,
    component: HomeAdmin,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.PORTAL_ROLE,
    exact: true,
    component: PortalRole,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.VIEW_POTAL_ROLE,
    exact: true,
    component: ViewPortalRole,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.PORTAL_ROLE_TAB,
    exact: true,
    component: PortalRoleTab,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.ORGANIZATION_CHART,
    exact: true,
    component: OrganizationChart,
    depts: ["*"],
    roles: ["*"],
  },

  {
    path: ROUTE_CONSTANT.TASKTYPE,
    exact: true,
    component: Tasktype,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.DEPARTMENT_ROLES,
    exact: true,
    component: DepartmentAndRoles,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.EDIT_DEPARTMENT_ROLES,
    exact: true,
    component: EditDepartmentAndRoles,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.APPROVALS,
    exact: true,
    component: Approvals,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.SCREEN_CONFIG,
    exact: true,
    component: ScreenConfiguration,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.SCREENS,
    exact: true,
    component: Screens,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.VIEW_TASKTYPE,
    exact: true,
    component: ViewTaskType,
    depts: ["*"],
    roles: ["*"],
  },

  {
    path: ROUTE_CONSTANT.EMAIL,
    exact: "",
    component: Email,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.EMAIL_CONFIG,
    exact: "",
    component: EmailConfig,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.UPDATE_TASKTYPEASSIGN,
    exact: true,
    component: UpdateTaskTypeAssign,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.MY_PROFILE,
    exact: true,
    component: MyProfile,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.PASSWORD_QUESTIONS,
    exact: true,
    component: PasswordQuestions,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.RESET_PASSWORD,
    exact: true,
    component: ResetPassword,
    isPublic: true,
  },
  {
    path: ROUTE_CONSTANT.VIEW_ERRORS,
    exact: true,
    component: ViewErrors,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.NOTIFICATION_TAB,
    exact: true,
    component: NotificationTab,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.VIEW_NOTIFICATION,
    exact: true,
    component: NotificationTab,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.TYPEOF_EMPLOYMENT,
    exact: true,
    component: TypeOfEmployment,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.EDIT_TYPEOF_EMPLOYMENT,
    exact: true,
    component: EditTypeOfEmployment,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.EDIT_EMAIL_CONFIG,
    exact: true,
    component: EditEmailConfig,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.CREATE_SEVA_TYPE,
    exact: true,
    component: CreateSevaType,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.VIEW_SEVA_TYPES,
    exact: true,
    component: ViewSevaTypes,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.CREATE_TEMPLE_MASTER,
    exact: true,
    component: CreateTempleMaster,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.VIEW_TEMPLE_MASTERS,
    exact: true,
    component: ViewTempleMasters,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.EDIT_TEMPLE_MASTER,
    exact: true,
    component: EditTempleMasters,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.SHEDULE_SEVA,
    exact: true,
    component: ScheduleSeva,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.EDIT_SCHEDULE_SEVA,
    exact: true,
    component: EditScheduleSeva,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.VIEW_SEVA_SCHEDULES,
    exact: true,
    component: ViewSevaSchedules,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.EDIT_SEVA_TYPE,
    exact: true,
    component: EditSeva,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.CREATE_DEVOTEE,
    exact: true,
    component: CreateDevotee,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.EDIT_DEVOTEE,
    exact: true,
    component: CreateDevotee,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.VIEW_DEVOTEES,
    exact: true,
    component: ViewDevotees,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.EDIT_DEVOTEE,
    exact: true,
    component: EditDevotees,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.DEVOTEE_OCCASION,
    exact: true,
    component: DevoteeOccasion,
    depts: ["*"],
    roles: ["*"],
  },

  {
    path: ROUTE_CONSTANT.EDIT_DEVOTEE_OCCASION,
    exact: true,
    component: DevoteeOccasion,
    depts: ["*"],
    roles: ["*"],
  },

  {
    path: ROUTE_CONSTANT.VIEW_DEVOTEE_OCCASIONS,
    exact: true,
    component: ViewDevoteeOccasions,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.EDIT_DEVOTEE_OCCASION,
    exact: true,
    component: EditDevoteeOccasions,
    depts: ["*"],
    roles: ["*"],
  },

  {
    path: ROUTE_CONSTANT.DONATION_TYPE,
    exact: true,
    component: CreateDonationType,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.VIEW_DONATION_TYPES,
    exact: true,
    component: ViewDonationTypes,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.VIEW_VOCHERS,
    exact: true,
    component: ViewVouchers,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.EDIT_DONATION_TYPE,
    exact: true,
    component: EditDonationType,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.CREATE_DONATIONS,
    exact: true,
    component: CreateDonations,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.VIEW_DONATIONS,
    exact: true,
    component: ViewDonations,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.EDIT_DONATIONS,
    exact: true,
    component: EditDonations,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.CREATE_DONATION_ITEMS,
    exact: true,
    component: CreateDonationItems,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.VIEW_DONATION_ITEMS,
    exact: true,
    component: ViewDonationItems,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.EDIT_DONATION_ITEMS,
    exact: true,
    component: EditDonationItems,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.CREATE_VOUCHER,
    exact: true,
    component: createVoucher,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.EDIT_VOUCHER,
    exact: true,
    component: createVoucher,
    depts: ["*"],
    roles: ["*"],
    exact: true,
    component: createVoucher,
    depts: ["*"],
    roles: ["*"],
  },

  {
    path: ROUTE_CONSTANT.CREATE_POOJA_BOOKING,
    exact: true,
    component: CreatePoojaBooking,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.VIEW_POOJA_BOOKING,
    exact: true,
    component: ViewPoojaBooking,
    depts: ["*"],
    roles: ["*"],
  },

  {
    path: ROUTE_CONSTANT.EDIT_POOJA_BOOKING,
    exact: true,
    component: EditPoojaBooking,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.APPROVAL_HIERACHY,
    exact: "",
    component: ApprovalHierachy,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.VIEW_APPROVAL_HIERARCHY,
    exact: "",
    component: ViewApprovalHierarchy,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.APPROVAL_HIERARCHY_SPECIFIC_DETAILS,
    exact: "",
    component: ApprovalHierarchySpecificDetails,
    depts: ["*"],
    roles: ["*"],
  },

  {
    path: ROUTE_CONSTANT.CREATE_RECEIPT_ATTACHMENT,
    exact: true,
    component: CreateReceiptAttachment,
    depts: ["*"],
    roles: ["*"],
  },

  {
    path: ROUTE_CONSTANT.CREATE_POOJA_RECEIPT,
    exact: true,
    component: CreatePoojaReciept,
    depts: ["*"],
    roles: ["*"],
  },

  {
    path: ROUTE_CONSTANT.DAILY_RECEIPT,
    exact: true,
    component: DailyReceipt,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.SASWATA_ANNAPRSADA_EXCEL,
    exact: true,
    component: SaswataAnnaPrsadaExcel,
    depts: ["*"],
    roles: ["*"],
  },


  {
    path: ROUTE_CONSTANT.VIEW_RECEIPT_ATTACHMENT,
    exact: true,
    component: viewReceiptAttachment,
    depts: ["*"],
    roles: ["*"],
  },

  {
    path: ROUTE_CONSTANT.EDIT_RECEIPT_ATTACHMENT,
    exact: true,
    component: editReceiptAttachment,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.EDIT_RECEIPT,
    exact: true,
    component: CreatePoojaReciept,
    depts: ["*"],
    roles: ["*"],
  },

  {
    path: ROUTE_CONSTANT.GET_ALL_RECEIPTS,
    exact: true,
    component: ViewPoojaReceipts,
    depts: ["*"],
    roles: ["*"],
  },


  {
    path: ROUTE_CONSTANT.DONOR_REPORT,
    exact: true,
    component: DonorReport,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.BALANCESHEET_REPORTS,
    exact: true,
    component: BalanceSheetReports,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.DEVOTEE_BY_SEVATYPE_REPORTS,
    exact: true,
    component: DevoteeBySevaTypes,
    depts: ["*"],
    roles: ["*"],
  },



  {
    path: ROUTE_CONSTANT.LOGS,
    exact: true,
    component: Logs,
    depts: ["*"],
    roles: ["*"],
  },
  {
    path: ROUTE_CONSTANT.VIEW_BOOK_DEMO,
    exact: true,
    component: ViewBookDemo,
    isPublic: true,
  },
];

export default routes;
